import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

const DEFAULT_LOGO = '/defaults/default-logo.svg';
const DEFAULT_ICON = '/defaults/default-icon.svg';
const DEFAULT_FLAG = '/defaults/default-flag.svg';

const handleImgError = (e, fallback) => { e.target.onerror = null; e.target.src = fallback; };

function Header() {
  const [logo, setLogo] = useState('');
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch promotions");
        const data = await response.json();
        setLogo(data[0].logo);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };
    fetchPromotions();
  }, []);

  const origin = window.location.origin.replace(/^https?:\/\/(aff\.)?/, '');
  const [isActive, setIsActive] = useState(false);
  const handleToggle = () => { setIsActive((prev) => !prev); };

  return (
    <header className="et-l et-l--header">
      <div className="et_builder_inner_content et_pb_gutters3">
        <div className="et_pb_section et_pb_section_0_tb_header et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_0_tb_header">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_header et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_0_tb_header">
                <div className="et_pb_code_inner">
                  <div className="mcwr-top clearfix">
                    <div className="language">
                      <Link to="#" onClick={e => e.preventDefault()} className="ftrigger curLang"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2023/08/bn-flag.jpg" alt="Language" onError={e => handleImgError(e, DEFAULT_FLAG)} />English</Link>
                    </div>
                    <div className="support">
                      <ul>
                        <li><Link to="/" className="icon-cs"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2024/03/icon-apk.png" alt="Download" onError={e => handleImgError(e, DEFAULT_ICON)} />Download App</Link></li>
                        <li><Link to="#" className="icon-cs intercom_custom_launcher"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2022/07/icon-cs.png" alt="Support" onError={e => handleImgError(e, DEFAULT_ICON)} />Affiliate Support</Link></li>
                        <li><Link to="#" target="_blank" className="telegram" rel="noopener noreferrer"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2022/07/icon-telegram.png" alt="Telegram" onError={e => handleImgError(e, DEFAULT_ICON)} />Telegram</Link></li>
                        <li><Link to={`mailto:affiliates@${origin}`} target="_blank" className="email" rel="noopener noreferrer"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2022/07/icon-mail.png" alt="Email" onError={e => handleImgError(e, DEFAULT_ICON)} />Email</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_1_tb_header et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_1_tb_header">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_1_tb_header et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_1_tb_header">
                <div className="et_pb_code_inner">
                  <div className="mcw-mainnav clearfix">
                    <div className="logo">
                      <Link to="/"><span><img decoding="async" src={logo ? `${process.env.REACT_APP_API_URL}/storage/${logo}` : DEFAULT_LOGO} alt="Logo" onError={e => handleImgError(e, DEFAULT_LOGO)} /></span></Link>
                    </div>
                    <div className="button">
                      <Link to="/login" className="login">Log In</Link>
                      <Link to="/signup" className="register">Sign Up</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_2_tb_header et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_2_tb_header">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_2_tb_header et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_2_tb_header">
                <div className="et_pb_code_inner">
                  <div className="mcw-dmenu">
                    <ul className="clearfix">
                      <li><Link to="/"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2022/07/icon-home-w.png" alt="Home" onError={e => handleImgError(e, DEFAULT_ICON)} /></Link></li>
                      <li><Link to="/commission-plan/">Commission</Link></li>
                      <li><Link to="/promotions/">Promotions</Link></li>
                      <li><Link to="/products/">Product</Link></li>
                      <li><Link to="/affiliate-guide/">Affiliate Guide</Link></li>
                      <li><Link to="/contact-us/">Contact Us</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_3_tb_header et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_3_tb_header">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_3_tb_header et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_3_tb_header">
                <div className="et_pb_code_inner">
                  <div className="mcw-rmobile clearfix">
                    <div className={`burger ${isActive ? "active" : ""}`} onClick={handleToggle}>
                      <Link to="#" onClick={e => e.preventDefault()}><span /><span /><span /></Link>
                    </div>
                    <div className="logo">
                      <Link to="/"><span><img decoding="async" src={logo ? `${process.env.REACT_APP_API_URL}/storage/${logo}` : DEFAULT_LOGO} alt="Logo" onError={e => handleImgError(e, DEFAULT_LOGO)} /></span></Link>
                    </div>
                    <div className="support">
                      <Link to="#" className="intercom_custom_launcher" target="_blank" rel="noopener noreferrer"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2022/07/header-service-icon.png" alt="Support" onError={e => handleImgError(e, DEFAULT_ICON)} />Affiliate Support</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`et_pb_section et_pb_section_4_tb_header et_section_regular ${isActive ? "active" : ""}`}>
          <div className="et_pb_row et_pb_row_4_tb_header">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_4_tb_header et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_4_tb_header">
                <div className="et_pb_code_inner">
                  <div className="mcwr-drawer">
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li><Link to="/commission-plan/">Commision</Link></li>
                      <li><Link to="/promotions/">Promotions</Link></li>
                      <li><Link to="/products/">Product</Link></li>
                      <li><Link to="/affiliate-guide/">Affiliate Guide</Link></li>
                      <li><Link to="/contact-us/">Contact Us</Link></li>
                      <li><Link to="/app_download/mcwaff.apk">Download App</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_5_tb_header et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_5_tb_header">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_5_tb_header et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_5_tb_header">
                <div className="et_pb_code_inner">
                  <div className="mcwrmm">
                    <ul>
                      <li><Link to="#" onClick={e => e.preventDefault()} className="ftrigger curLang"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2023/08/bn-flag.jpg" alt="Language" onError={e => handleImgError(e, DEFAULT_FLAG)} />English</Link></li>
                      <li><Link to="/signup">Sign Up</Link></li>
                      <li><Link to="/login">Login</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
